import styled from 'styled-components';

export const QuestionBlock = styled.div`
  margin: 0 auto;
`;
